function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#7799a1",
  fillRule: "evenodd",
  transform: "rotate(90)",
  d: "M14.15 2.6L11.5.12c-.17-.16-.45-.16-.62 0-.18.17-.17.45-.17.72V2.1H3.6V.83c0-.27 0-.55-.17-.72-.16-.14-.45-.14-.62 0L.14 2.6c-.1.08-.14.2-.13.3 0 .13.03.25.13.33L2.77 5.7c.17.17.46.17.63 0 .18-.16.17-.53.17-.7V3.75h7.14V5c0 .27 0 .54.2.7.17.17.45.17.63 0l2.65-2.47c.1-.08.13-.2.13-.32 0-.1-.03-.2-.12-.3"
});

var SvgArrowHeight = function SvgArrowHeight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 6,
    height: 15,
    viewBox: "-6 0 6 15",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowHeight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-height.97cb8b71.svg";
export { ForwardRef as ReactComponent };